import { last, isEmpty } from 'lodash'
import { centsToDollars } from './formatters'
import { getCreditCardType } from '../viewmodels/TabOrderViewModel'

const paymentKey = {
  VISA: 'visa',
  MAST: 'mastercard',
  MC: 'mastercard',
  DISC: 'discover',
  AMEX: 'american express',
}

const isPhysicalCard = (payment) => {
  const isCredit = payment?.paymentType === 'freedompay_credit'
  const isToken = payment?.paymentType === 'freedompay_token'
  const hasUserAttributes = !isEmpty(payment?.userAttributes)

  return isCredit || (isToken && hasUserAttributes)
}

const capitalizeWords = (str) => {
  if (!str) return str

  // If there are double spaces or tab characters in the string, this function breaks
  const sanitzedString = str.trim().replace(/(\s|\t){1,}/g, ' ')
  const words = sanitzedString.split(' ')
  const result = words.reduce((accumulator, word) => {
    return `${accumulator}${!accumulator ? '' : ' '}${word[0].toUpperCase() + word.slice(1)}`
  }, '')

  return result
}

const getCardInfo = (payment) => {
  let cardType
  let paymentName

  const customerPayment = paymentKey[payment?.shortDescription?.split?.(' ')?.[0]?.toUpperCase()]
  const isCredit = payment?.paymentType === 'freedompay_credit'
  const isToken = payment?.paymentType === 'freedompay_token'
  const hasUserAttributes = !isEmpty(payment?.userAttributes)

  if (customerPayment) {
    cardType = customerPayment
    paymentName = last(payment?.shortDescription?.split?.(' ')) ?? 'Unknown'
  } else if (isCredit || (isToken && hasUserAttributes)) {
    cardType = getCreditCardType(payment)
    paymentName = payment?.userAttributes?.last4 ?? 'Unknown'
  } else {
    cardType = payment?.shortDescription ?? payment?.paymentType
    paymentName = payment?.shortDescription ?? payment?.paymentType
  }

  return [cardType, paymentName]
}

export const formatPayments = (payments, showFullPayment) => {
  return payments.map((payment) => {
    const [cardType, paymentName] = getCardInfo(payment)
    const paymentAmount = showFullPayment ? centsToDollars(payment.amountInCents) : centsToDollars(payment.amountInCents - payment.tip)
    const paymentType = payment?.paymentType ?? payment?.shortDescription?.replace(' ', '_')?.toLowerCase() ?? ''

    return {
      cardType,
      label: `${capitalizeWords(paymentName)} • ${paymentAmount}`,
      id: payment.uuid,
      ...payment,
      paymentType,
    }
  })
}

const filterValidPayments = ({ payments, showFullPayment }) => {
  const validPayments = payments?.filter(payment => payment.amountInCents > 0)

  return formatPayments(validPayments, showFullPayment)
}

export default filterValidPayments
